/**
 * Valida si la hora de finalización es mayor que la de inicio.
 * @param {string} startTime - Hora de inicio en formato HH:mm.
 * @param {string} endTime - Hora de finalización en formato HH:mm.
 * @returns {boolean} - true si el rango es válido, false en caso contrario.
 */
export const isValidTimeRange = (startTime, endTime) => {
    return startTime && endTime && startTime < endTime;
};

export const validateForm = (selectedAvailability, rotativeText, startTime, endTime) => {
    if (selectedAvailability === 'rotative') {
        return rotativeText.trim().length > 0;
    } else {
        return selectedAvailability && startTime !== '' && endTime !== '' && isValidTimeRange(startTime, endTime);
    }
};
